import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { InjectedRouter } from 'react-router';

import Backdrop from 'components/util/loader/.mixins';
import { TopBar } from './components/TopBar';
import { SuppliersDropdown } from './components/SuppliersDropdown';
import { OrdersTable } from './components/OrdersTable';
import { ErrorBoundary } from 'hooks/ErrorBoundary/ErrorBoundary';
import { Filters } from './components/Filters';

import { AuthContext } from 'contexts/AuthContext';
import { IOrderFilters, useOrders } from './hooks/useOrders';
import { useSnackbar } from 'hooks/useSnackbar';
import { useSuppliers } from 'hooks/useSuppliers';
import { FiltersProvider } from './hooks/FiltersContext';
import { usePagination } from 'hooks/usePagination';

import { useStyles } from './styles';
import { addMonthsToDate } from 'components/util/Helpers/DateHelpers';

export interface IRouterProps {
  router: InjectedRouter;
}

export const OrderHistory = ({ router }: IRouterProps) => {
  const classes = useStyles();

  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  const { Snackbar, toggleSnackbar } = useSnackbar({ severity: 'error', autoHideDuration: 8000 });

  const { currentSupplierId, handleChangeSupplier } = useSuppliers();

  const { Pagination, nextRows, initialRow, setTotalRows, clearPagination } = usePagination();

  const [filters, setFilters] = useState(() => {
    const currentDate = new Date();
    const lastMonth = addMonthsToDate(currentDate, -1);

    return {
      finalIssueDate: currentDate.toLocaleDateString('pt-br'),
      initialIssueDate: lastMonth.toLocaleDateString('pt-br')
    } as IOrderFilters;
  });

  const { loading, orders, error } = useOrders({
    filters: { personId: currentSupplierId, statusSciaIs: 'T', initialRow, nextRows, ...filters }
  });

  useEffect(() => {
    if (orders && orders.length > 0) {
      setTotalRows(orders[0].totalRows);
    }
    if (orders && orders.length === 0) {
      setTotalRows(0);
    }
  }, [orders]);

  useEffect(() => {
    if (error) {
      toggleSnackbar();
    }
  }, [error]);

  return (
    <FiltersProvider
      filters={filters}
      setFilters={setFilters}
      clearPagination={clearPagination}
      currentSupplierId={currentSupplierId}
    >
      <TopBar router={router} />

      <Box className={classes.container}>
        {isVisaoTok && <SuppliersDropdown handleChange={handleChangeSupplier} />}

        <Filters />

        <ErrorBoundary message="Ocorreu um problema ao carregar as informações da tabela. Por favor, tente novamente.">
          <OrdersTable orders={orders!} error={error} />
        </ErrorBoundary>

        <Pagination />
      </Box>

      <Snackbar>Ocorreu um problema ao carregar as informações da tabela. Por favor, tente novamente.</Snackbar>

      {loading && <Backdrop state={{ isLoading: loading }} />}
    </FiltersProvider>
  );
};
